import Head from 'next/head';
import React from 'react';

import {HeadSEO} from '@udemy/head-seo';
import {useI18n} from '@udemy/i18n';

import {getLayout} from 'src/components/layout';
import {useCanonicalUrl} from 'src/hooks/useCanonicalUrl';
import {META_DEFAULT_BASE_URL} from 'src/lib/constants';

import {FeaturedTopics} from './featured-topics.react-component';

import './index.module.less';

export function FeaturedTopicsPage({locale}: {locale: string}) {
    const {gettext} = useI18n();
    const {url: canonicalUrl} = useCanonicalUrl([], META_DEFAULT_BASE_URL);

    return (
        <>
            <HeadSEO
                ogTitle={gettext('Popular and trending topics')}
                description={gettext(
                    'Learn something completely new or improve your existing skills',
                )}
                ogDescription={gettext(
                    'Learn something completely new or improve your existing skills',
                )}
                ogType="video_lecture"
                ogLocale={process.env.I18N_PATH_TO_BUNDLE_MAP[locale]}
                canonicalUrl={canonicalUrl}
                assetPath={process.env.ASSET_PREFIX}
                headWrapper={Head}
            />
            <div className="ud-main-content-wrapper">
                <FeaturedTopics />
            </div>
        </>
    );
}

FeaturedTopicsPage.getLayout = getLayout;
